export const EMPLOYMENT_TYPE_MAP = {
	fullTime: 'Full time',
	partTime: 'Part time',
};

export const crewMemberNoData = 'No data';
export const crewMemberNoneAvailable = '(none available)';
export const NA_CLASSIFICATION_LABEL = 'N/A';
